module.exports = __webpack_public_path__ + "static/media/get-the-look.718815b2.mp4";